// Masked, revealable, copyable license key.

import { useState } from 'react';
import { Copy, Check, Eye, EyeOff } from 'lucide-react';

function maskKey(key: string): string {
  if (key.length <= 12) return key;
  return key.slice(0, 12) + '\u2022'.repeat(16);
}

export function LicenseKeyDisplay({ licenseKey }: { licenseKey: string }) {
  const [revealed, setRevealed] = useState(false);
  const [copied, setCopied] = useState(false);

  const copyKey = async () => {
    await navigator.clipboard.writeText(licenseKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="flex items-center gap-2 mt-2 bg-secondary border border-border rounded-md px-3 py-2">
      <input
        type="text"
        readOnly
        value={revealed ? licenseKey : maskKey(licenseKey)}
        className="flex-1 min-w-0 bg-transparent text-xs font-mono text-foreground border-none outline-none cursor-default truncate"
        onClick={(e) => { if (revealed) (e.target as HTMLInputElement).select(); }}
      />
      <button
        onClick={() => setRevealed(!revealed)}
        className="text-muted-foreground hover:text-foreground transition-colors p-1 shrink-0"
        title={revealed ? 'Hide' : 'Reveal'}
      >
        {revealed ? <EyeOff className="w-3.5 h-3.5" /> : <Eye className="w-3.5 h-3.5" />}
      </button>
      <button
        onClick={copyKey}
        className="text-muted-foreground hover:text-foreground transition-colors p-1 shrink-0"
        title="Copy license key"
      >
        {copied ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <Copy className="w-3.5 h-3.5" />}
      </button>
    </div>
  );
}
